import {
  Box,
  Checkbox,
  FormControl, FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useState } from "react";
import { Create } from "react-admin";

//Enum
import { ShortTimeEnum } from "../../enums/ShortTimeEnum";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";

//Services
import { OneMealService } from "../../services/OneMealService";

//Components
import CommonDialogForUserAndHouse from "../Common/CommonDialogUserAndHouse";
import ResourceSelectDialog from "../Common/ResourceSelectDialog";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import CouponsSelectDialog from "../Common/CouponsSelectDialog";
import CircularLoader from "../Common/CircularLoader";
import OccasionList from "../Common/OccasionList";
import HouseList from "../Houses/HouseList";

//Store
import { setCustomSelectOpen } from "../../store/reducers/customSelect";
import { useAppDispatch } from "../../store/hooks";

//Events
import EventBus from "../../EventBus";
import { useNavigate } from "react-router-dom";

//Common Styles
import { 
  BlueBorderContainer, 
  BlueTOpBorderContainer, 
  ButtonContainer, 
  FilledButton, 
  FormFieldGroup, 
  FormGrid, 
  FormLabel, 
  OutlinedButton, 
  SectionTitleRow, 
  StyledDateText, 
  StyledSelect, 
  WorkspaceContainer, 
  WorkspaceHeader, 
  WorkspaceIconBadge, 
  WorkspacePanel, 
  WorkspaceTitle 
} from "../../styles/commonStyles";

//Svg Icons
import { EditIcon, HouseIcon, UserIcon } from "../Svg";

//Colors
import { colors } from "../../styles/colors";
import { useSlotSizeOptions } from "../../utils/SlotSizeOptions";

const oneMealService = new OneMealService();

const OneMealServiceCreate = () => {
  const [time, setTime] = useState<string>("");
  const [slotSize, setSlotSize] = useState<number | null>(null);
  const slotSizeOptions = useSlotSizeOptions();
  const [date, setDate] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [hasOptedPayAfterService, setHasOptedPayAfterService] = useState(false);
  const [houseId, setHouseId] = useState<any>(null);
  const [openHouseDialog, setOpenHouseDialog] = useState(false);
  const [openCouponDialog, setOpenCouponDialog] = useState(false);
  const [occasion, setOccasion] = useState<string>("");
  const [coupon, setCoupon] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [serviceType, setServiceType] = useState<"CHEFIT" | "INSTANT_CHEFIT">(
    "CHEFIT"
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSelectHouse = () => {
    setOpenHouseDialog(true);
    dispatch(
      setCustomSelectOpen({
        open: true,
      })
    );
  };
  const handleSelectCoupon = () => {
    setOpenCouponDialog(true);
  }

  const handleOpen = (value: boolean) => {
    if (value) {
      handleSelectHouse();
    }
    else {
      handleSelectCoupon();
    }
  };

  const handleCloseHouse = (record: any) => {
    setOpenHouseDialog(false);
    setHouseId(record?.id);
  };

  async function createInstantChefit() {
    setLoading(true);

    oneMealService
      .createInstantChefit(
        {
          totalPeople: null,
          slotSize,
          discountCouponId: coupon ? coupon.id : null,
          date: moment().format("YYYY-MM-DD"),
        },
        houseId
      )
      .then((data) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Success",
          type: CustomSnackbarTypes.SUCCESS,
        });

        setLoading(false);

        if (data?.id) {
          navigate(`/OneMealService/${data.id}/show`, { replace: true });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);

        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: err.response.data.error,
          type: CustomSnackbarTypes.ERROR,
        });
      });
  }


  async function createOneMealService() {
    setLoading(true);
    oneMealService
      .createOneMealService({
        houseId,
        totalPeople: null,
        slotSize,
        time,
        date: moment(date).format("YYYY-MM-DD"),
        hasOptedPayAfterService,
        ...(hasOptedPayAfterService ? {} : { useWalletCash: true }),
        occasion,
        discountCouponId: coupon?.id,
      })
      .then((data) => {
        if (!coupon || data?.paymentStatus === "PAID") {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Success",
            type: CustomSnackbarTypes.SUCCESS,
          });
          setLoading(false);
          if (data?.id) {
            navigate(`/OneMealService/${data?.id}/show`, { replace: true });
          }
        }
        else {
          oneMealService.createRazaorPayOrder(data?.id, coupon?.id).then((order) => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Success",
              type: CustomSnackbarTypes.SUCCESS,
            });
            setLoading(false);
            if (data?.id) {
              navigate(`/OneMealService/${data?.id}/show`, { replace: true });
            }
          }).catch((err) => {
            setLoading(false);
            console.log(err);
          })
        }
      }).catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }
  const handleSubmit = async () => {
    createOneMealService();
  };

  const handleInstantChefitSubmit = async () => {
    createInstantChefit()
  }

  return (
    <WorkspaceContainer>
      <WorkspaceHeader>
        <SectionTitleRow>
          <WorkspaceIconBadge>
            <EditIcon />
          </WorkspaceIconBadge>
          <div>
            <WorkspaceTitle>Create Chefit Booking</WorkspaceTitle>
          </div>
        </SectionTitleRow>

        <ButtonContainer>
          <FormControl>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <>
                <Radio
                  checked={serviceType === "CHEFIT"}
                  onChange={() => setServiceType("CHEFIT")}
                />
                <span>Chefit</span>
              </>
              <>
                <Radio
                  checked={serviceType === "INSTANT_CHEFIT"}
                  onChange={() => setServiceType("INSTANT_CHEFIT")}
                />
                <span>Instant Chefit</span>
              </>
            </div>
          </FormControl>
        </ButtonContainer>
      </WorkspaceHeader>

      {loading ? <CircularLoader /> :
        (<WorkspacePanel>
          <BlueBorderContainer>
            <div>
              <Grid item xs={4}>
                <Box display={"flex"} gap={"1rem"}>
                  <FilledButton onClick={() => handleOpen(true)}>
                    <HouseIcon />
                    {houseId ? `house Id: ${houseId}` : "Choose House"}
                  </FilledButton>
                  {houseId &&
                    <FilledButton onClick={() => handleOpen(false)}>
                      <HouseIcon />
                      {coupon ? `coupon Id: ${coupon?.couponCode}` : "Choose Coupon"}
                    </FilledButton>
                  }
                </Box>
              </Grid>
            </div>
            <div>
              {
                houseId &&
                <CouponsSelectDialog
                  open={openCouponDialog}
                  houseId={houseId}
                  callback={() => setOpenCouponDialog(false)}
                  setCoupon={setCoupon}
                  productTypeFilter={serviceType === "CHEFIT" ? "ONE_MEAL_SERVICE" : undefined}
                />
              }
              <CommonDialogForUserAndHouse
                open={open}
                setOpen={setOpen}
                setHouse={setHouseId}
              />
              {openHouseDialog && (
                <ResourceSelectDialog
                  name={"Houses"}
                  list={HouseList}
                  onClose={handleCloseHouse}
                />
              )}
              <OutlinedButton onClick={() => setOpen(true)}>
                <UserIcon color={colors.primary} width={28} height={28} />
                Create Customer and House
              </OutlinedButton>
            </div>

          </BlueBorderContainer>

          <Grid item xs={4}>
            {
              !coupon ? <Box>No Coupon Selected ...</Box> :
                <TableContainer component={Paper}>
                  <Table aria-label="coupon table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Coupon Code</TableCell>
                        <TableCell>Product Type</TableCell>
                        <TableCell>Coupon Type</TableCell>
                        <TableCell>Coupon Value</TableCell>
                        <TableCell>Maximum Amount</TableCell>
                        <TableCell>Is Active</TableCell>
                        <TableCell>Expiry Time</TableCell>
                        <TableCell>Total Time Used</TableCell>
                        <TableCell>Usage Limit</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={coupon?.couponCode}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell scope="row">{coupon?.couponCode}</TableCell>
                        <TableCell align="left">{coupon?.productType ?? "—"}</TableCell>
                        <TableCell align="left">{coupon?.couponType}</TableCell>
                        <TableCell align="left">{coupon?.couponValue}</TableCell>
                        <TableCell align="left">{coupon?.maximumDiscountAmount}</TableCell>
                        <TableCell align="left">{coupon?.isActive ? "YES" : "NO"}</TableCell>
                        <TableCell align="left">{moment(coupon?.expiresAt).format('DD-MM-YYYY hh:mm A')}</TableCell>
                        <TableCell align="left">{coupon?.totalTimesUsed}</TableCell>
                        <TableCell align="left">{coupon?.maximumUsageLimit}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
            }
          </Grid>

          {serviceType === "CHEFIT" ? (
            <Create title={"Create One Meal Service"} sx={{
              "& .RaCreate-card": {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
              }
            }}>
              <>
                <FormGrid>
                  <FormFieldGroup>
                    <FormLabel>Date</FormLabel>
                    <FormControl style={{ width: "100%" }}>
                      <DatePicker
                        inputFormat="dd MMM yyyy"
                        disableMaskedInput
                        minDate={new Date()}
                        value={date}
                        onChange={(value: any) => {
                          setDate(moment(value).format("YYYY-MM-DD"));
                        }}
                        renderInput={(params: any) => <StyledDateText {...params} label="" variant="outlined" />}
                      />
                    </FormControl>
                  </FormFieldGroup>

                  <FormFieldGroup>
                    <FormLabel>Slot Size (Hours)</FormLabel>
                    <FormControl style={{ width: "100%" }}>
                      <StyledSelect
                        labelId="forSlotSize"
                        id="slotSize"
                        variant="outlined"
                        value={slotSize ?? ""}
                        label="Slot Size"
                        onChange={(event: any) => {
                          setSlotSize(event.target.value);
                        }}
                      >
                        {slotSizeOptions.map((e) => (
                          <MenuItem key={e} value={e}>
                            {e} hr{e !== 1 ? "s" : ""}
                          </MenuItem>
                        ))}
                      </StyledSelect>
                    </FormControl>
                  </FormFieldGroup>
                </FormGrid>

                <FormGrid>
                  <FormFieldGroup>
                    <FormLabel>One Meal Time</FormLabel>
                    <FormControl style={{ width: "100%" }}>
                      <StyledSelect
                        labelId="forTime"
                        id="time"
                        variant="outlined"
                        value={time}
                        label="One Meal Time"
                        onChange={(event: any) => {
                          setTime(event.target.value);
                        }}
                      >
                        {Object.values(ShortTimeEnum).map((e) => (
                          <MenuItem key={e} value={e}>
                            {e}
                          </MenuItem>
                        ))}
                      </StyledSelect>
                    </FormControl>
                  </FormFieldGroup>

                  <FormFieldGroup>
                    <FormLabel>Occasion Type</FormLabel>
                    <OccasionList occasion={occasion} setOccasion={setOccasion} module={ReasonSubreasonModuleEnum.ONE_MEAL_SERVICE} actionType={ActionTypeEnum.OCCASION} />
                  </FormFieldGroup>
                </FormGrid>

                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hasOptedPayAfterService}
                        onChange={(e) => {
                          setHasOptedPayAfterService(e.target.checked);
                        }}
                        name="Pay After Service"
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: `${colors.primary}`

                          }
                        }}
                      />
                    }
                    label="Pay After Service"
                  />
                </div>
                <BlueTOpBorderContainer >
                  <FilledButton
                    variant="contained"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{ padding: '6px 32px' }}
                  >
                    Submit
                  </FilledButton>
                </BlueTOpBorderContainer>

              </>
            </Create>
          ) : (
            <Create title={"Create One Meal Service"} sx={{
              "& .RaCreate-card": {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
              }
            }}>
              <>
                <div style={{ marginTop: "20px" }}>
                  <FormFieldGroup>
                    <FormLabel>Slot Size (Hours)</FormLabel>
                    <FormControl style={{ width: "100%" }}>
                      <StyledSelect
                        labelId="forSlotSize"
                        id="slotSize"
                        variant="outlined"
                        value={slotSize ?? ""}
                        label="Slot Size"
                        onChange={(event: any) => {
                          setSlotSize(event.target.value);
                        }}
                      >
                        {slotSizeOptions.map((e) => (
                          <MenuItem key={e} value={e}>
                            {e} hr{e !== 1 ? "s" : ""}
                          </MenuItem>
                        ))}
                      </StyledSelect>
                    </FormControl>
                  </FormFieldGroup>
                </div>

                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hasOptedPayAfterService}
                        onChange={(e) => {
                          setHasOptedPayAfterService(e.target.checked);
                        }}
                        name="Pay After Service"
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: `${colors.primary}`

                          }
                        }}
                      />
                    }
                    label="Pay After Service"
                  />
                </div>
                <BlueTOpBorderContainer >
                  <FilledButton
                    variant="contained"
                    onClick={() => {
                      handleInstantChefitSubmit();
                    }}
                    style={{ padding: '6px 32px' }}
                  >
                    Submit
                  </FilledButton>
                </BlueTOpBorderContainer>

              </>
            </Create>
          )}


        </WorkspacePanel>)}
    </WorkspaceContainer>
  );
};

export default OneMealServiceCreate;
